import { SendSMS } from "../../DriveScout/API/models/NotificationModel";

const state = {
  flashMessage: {
    type: "",
    message: "",
  },
};

const mutations = {
  ADD_FLASH_MESSAGE(state, data) {
    state.flashMessage.message = data.message;
    state.flashMessage.type = data.type;
  },
};

const actions = {
  ADD_FLASH_MESSAGE({ commit }, data) {
    commit("ADD_FLASH_MESSAGE", data);
  },
  SEND_SMS({ commit }, smsData) {
    return SendSMS(smsData).then((response) => {
      return response;
    });
  },
};

const getters = {
  flashMessage: (state) => state.flashMessage,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

